import { useTranslation } from 'react-i18next';
import {
  AssetType,
  type CreateDataRequestDto,
  DataType,
  ReasonForDataRequest,
} from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

const { ConditionalField, FormTextArea } =
  typedFormFields<CreateDataRequestDto>();

export const DataTypeNote = () => {
  //Licht hier je verzoek zo specifiek mogelijk toe
  const { t } = useTranslation('dataRequest');

  return (
    <ConditionalField
      field="dataTypeNote"
      condition={(formValue) => {
        return (
          ((!!formValue('energyTypesConsumption') &&
            formValue('energyTypesConsumption')!.length > 0) ||
            (!!formValue('assetTypes') &&
              !formValue('assetTypes')!.includes(AssetType.Other)) ||
            (!!formValue('assetTypeNote') &&
              formValue('assetTypeNote')!.length > 2) ||
            (!!formValue('dataTypes') &&
              formValue('dataTypes')?.includes(DataType.KeyFigures)) ||
            (!!formValue('reason') &&
              formValue('reason') === ReasonForDataRequest.OptimiseBulkUse)) ??
          false
        );
      }}
    >
      <FormTextArea
        name="dataTypeNote"
        label={t('data_type_note')}
        fullWidth
        showWordCount
        rules={{ maxLength: 2000, minLength: 2, required: true }}
      />
    </ConditionalField>
  );
};
